export default __webpack_public_path__ + "images/price-icon_2.svg?dacc9618494ade2daa2c98a19acf6408";